import React from 'react';

import { OptionalDataTestIdProp } from 'Shared/utils/props/dataTestIdProp';

interface FlexProps {
  children: React.ReactNode;
  direction?: 'row' | 'column'; // Main axis
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse'; // Wrapping behavior
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'; // Alignment along the main axis
  align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline'; // Alignment along the cross axis
  className?: string;
  style?: React.CSSProperties;
}

export const Flex: React.FC<FlexProps & OptionalDataTestIdProp> = props => {
  const {
    children,
    direction = 'row',
    wrap = 'nowrap',
    justify = 'flex-start',
    align = 'stretch',
    className = '',
    style = {},
    'data-testid': dataTestId,
  } = props;

  const flexStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: direction,
    flexWrap: wrap,
    justifyContent: justify,
    alignItems: align,
    ...style,
  };

  return (
    <div data-testid={dataTestId} className={className} style={flexStyles}>
      {children}
    </div>
  );
};
